import { Link } from "react-router-dom";
import { hasPermission } from "../utils/permissions";

export default function Sidebar({ isOpen, onClose }) {
    return (
        <>
            {/* Mobile overlay */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 md:hidden"
                    onClick={onClose}
                />
            )}

            <div
                className={`
            fixed md:relative
            inset-y-0 left-0
            z-50
            w-56 md:w-64
            min-h-screen
            bg-blue-900
            text-white
            p-4
            flex-shrink-0
            transform
            transition-transform
            duration-300
            ${isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
        `}
            >

            <h1 className="text-2xl font-bold mb-8">
                School ERP
                </h1>

                <button
                    type="button"
                    onClick={onClose}
                    className="absolute top-4 right-4 text-white text-2xl md:hidden"
                    aria-label="Close menu"
                >
                    �
                </button>

            {hasPermission("dashboard") && (
                <Link
                        to="/dashboard"
                        onClick={onClose}
                        className="block text-sm md:text-lg hover:text-yellow-300"
                >
                    Dashboard
                </Link>
                )}


                <nav className="space-y-5 text-sm md:text-lg" onClick={onClose}>

                {hasPermission("students") && (
                    <>
                            <p className="font-semibold text-yellow-300 text-sm md:text-lg mt-2">
                            Students
                        </p>

                        <Link
                            to="/student-admission"
                            className="block pl-4 hover:text-yellow-300"
                        >
                            Student Admission
                        </Link>

                        <Link
                            to="/student-directory"
                            className="block pl-4 hover:text-yellow-300"
                        >
                            Student Directory
                        </Link>
                    </>
                )}

                

                {hasPermission("fees") && (
                    <Link
                        to="/fees"
                        className="block hover:text-yellow-300"
                    >
                        Fees
                    </Link>
                )}


            



                {hasPermission("fee_history") && (
                    <Link
                        to="/fee-history"
                        className="block hover:text-yellow-300"
                    >
                        Fee History
                    </Link>
                )}

                {hasPermission("attendance") && (
                    <Link
                        to="/attendance"
                        className="block hover:text-yellow-300"
                    >
                        Attendance
                    </Link>
                )}

                {hasPermission("attendance_history") && (
                    <Link
                        to="/attendance-history"
                        className="block hover:text-yellow-300"
                    >
                        Attendance History
                    </Link>
                )}

                {hasPermission("staff") && (
                    <Link
                        to="/staff"
                        className="block hover:text-yellow-300"
                    >
                        Staff
                    </Link>
                )}

                {hasPermission("salary") && (
                    <Link
                        to="/salary"
                        className="block hover:text-yellow-300"
                    >
                        Salary and Expense Entry
                    </Link>
                )}

                {hasPermission("salary_history") && (
                    <Link
                        to="/salary-history"
                        className="block hover:text-yellow-300"
                    >
                        Salary History
                    </Link>
                )}

                {hasPermission("exam_marks") && (
                    <Link
                        to="/exam-marks"
                        className="block hover:text-yellow-300"
                    >
                        Exam Marks
                    </Link>
                )}

                {hasPermission("results") && (
                    <Link
                        to="/result-history"
                        className="block hover:text-yellow-300"
                    >
                        Results
                    </Link>
                )}

                {hasPermission("promotion") && (
                    <Link
                        to="/promotion"
                        className="block hover:text-yellow-300"
                    >
                        Promotion
                    </Link>
                )}

                {hasPermission("notifications") && (
                    <Link
                        to="/notifications"
                        className="block hover:text-yellow-300"
                    >
                        Notifications
                    </Link>
                )}

                {hasPermission("transport") && (
                    <Link
                        to="/transport"
                        className="block hover:text-yellow-300"
                    >
                        Transport
                    </Link>
                )}

                {hasPermission("transport_assignment") && (
                    <Link
                        to="/transport-assignment"
                        className="block hover:text-yellow-300"
                    >
                        Transport Assignment
                    </Link>
                )}

                {hasPermission("settings") && (
                    <Link
                        to="/settings"
                        className="block hover:text-yellow-300"
                    >
                        Settings
                    </Link>
                )}

                {hasPermission("permissions") && (
                    <Link
                        to="/permissions"
                        className="block hover:text-yellow-300"
                    >
                        Permissions
                    </Link>
                )}

                {hasPermission("users") && (
                    <Link
                        to="/users"
                        className="block hover:text-yellow-300"
                    >
                        User Management
                    </Link>
                )}

            </nav>
            </div>
        </>
    );
}